import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'pa-select-card',
  templateUrl: './select-card.component.html',
  styleUrls: ['./select-card.component.scss']
})
export class SelectCardComponent implements OnInit {

  cards = [
    {
      id: 'paycell-card',
      title: 'Paycell Kart',
      description: 'Fiziksel Paycell Kartını bu adımdan aktive edebilirsin',
      imageUrl: 'assets/images/paycell-card.png'
    },
    {
      id: 'credit-card',
      title: 'Kredi/Banka Kartı',
      description: 'Visa, MastercardiTroy markalı kredi ve banka kartlarını ekleyebilirsin',
      imageUrl: 'assets/images/credit-card.png'
    },
    {
      id: 'create-virtual-card',
      title: 'Sanal Kart Oluştur',
      description: 'İnternet alışverişlerinde güvende kullanabilirsin',
      imageUrl: 'assets/images/create-virtual-card.png'
    },
    {
      id: 'spending-money-card',
      title: 'Harçlık Kart',
      description: 'Çocuğunun harcamalarını ve bakiyesini anlık olarak takip edebilirsin.',
      imageUrl: 'assets/images/spending-money-card.png'
    }
  ];

  trackingId: string;

  constructor(private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
  }

  routingCreateCard(id: string) {
    this.router.navigate([`/payment/create-card/${id}`, this.trackingId]);
  }
}
